import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { FullWidthLayout, MasterLayout } from '@/components/templates';
import { useAuthContext } from '@/context';
import { usePageLoading } from '@/hooks';

export const AppLayout: FC<PropsWithChildren> = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { isSignedIn } = useAuthContext();

  useEffect(() => {
    setIsLoading(false);
  }, []);

  usePageLoading(isLoading);

  if (isLoading) {
    return null;
  }

  if (!isSignedIn) {
    return <FullWidthLayout>{children}</FullWidthLayout>;
  }

  return <MasterLayout>{children}</MasterLayout>;
};
